<script>
import { bookingsService } from "../../services";
import { booking_statuses, get_currency } from '../../Helper/helper';
import BookingReject from './tabs/booking-reject.vue';
import Swal from "sweetalert2";
export default {
	components: {
		BookingReject
	},
	props: {
			'showModal':{
				type:Boolean
			},
			'booking_id':{
				type:String
			},
	},
	data() {
		return {
			currency: get_currency(),
			showReject: false,
			booking_statuses:booking_statuses,
			booking: null,
			isVisible: this.showModal
		};
	},
	mounted() {
		console.log(this.booking_id);
		
		this.newBookingDetails(this.booking_id);
	},
	methods: {
		newBookingDetails(booking_id)
		{
			bookingsService.getNewBookingDetails({booking_id:booking_id}).then((response) => 
			{
				if(response.data.code == 200)
				{
					this.booking = response.data.result;
					console.log("New Pending Booking:", this.booking);
					
					// if(this.booking && Object.keys({...this.booking}).length > 0 && this.booking.booking_id)
					// {
					// 	this.booking_id = this.booking.booking_id;
					// }
				}	
			});
		},
		acceptBooking(booking_id,status)
		{
			Swal.fire({
				title: "Are you sure you want to confirm this booking?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#34c38f",
				cancelButtonColor: "#f46a6a",
				confirmButtonText: "Yes"
			}).then(result => 
			{
				if (result.value) 
				{
					const data = {booking_id: booking_id, status: status, from_model: true};
            		bookingsService.changeBookingsStatusApi(data)
					.then(response => {
						console.log(response);
						
						if(response.data.code == 200){
							Swal.fire("Confirmed!", "#"+ booking_id + " booking has been confirmed.", "success");
						}else{

							if(response.data.message)
							{
								Swal.fire("Failed!", "#"+ booking_id + " " + response.data.message, "danger");
							}
							else
							{
								Swal.fire("Failed!", "#"+ booking_id + " booking is not confirmed.", "danger");
							}

						}
						this.$emit('close');
						this.$emit('refreshData')
					})
				}
			});
		},
		btoa(str)
		{
			return btoa(str);
		},
		closeModal() {
			this.$emit('close'); // Emit event to close the modal
		},
		getBookingData(){
			this.$emit('refreshData');
		}
	}
};
</script>

<template>
	<div>
		<b-modal v-if="booking" v-model="isVisible" class="booking_placed" scrollable :title="trans.get('__JSON__.Booking No')+' '+(booking && booking.booking_id || '000')" title-class="font-18" centered size="lg" @close="closeModal"  @hidden="closeModal">
			<b-form>
				<div class="row settings-main">
					<div class="col-md-12">
						<div class="row sections-main">
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get("__JSON__.Vendor's Name",{ vendor: $auth.getRestaurantName() })}}</h6>
									<p><b-link :to="{ name: 'vendor-detail', params:{restaurant_id: btoa(booking.restaurant_id) }}">{{ booking.vendor_name }}</b-link></p>
								</div>
							</div>
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get("__JSON__.Customer's Name")}}</h6>
									<p><b-link :to="{ name: 'customer-detail', params:{user_id: btoa(booking.user_id) }}">{{ booking.customer_name }}</b-link></p>
								</div>
							</div>
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get("__JSON__.Customer's Phone")}}</h6>
									<p>{{ booking.user_mobile_number }}</p>
								</div>
							</div>
						</div>
					</div>
	
					<div class="col-md-12">
						<div class="row  sections-main">
							<div class="col-md-4 mt-1" v-if="booking.created_at">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Placement time')}}</h6>
									<p v-if="booking.created_at != '0000-00-00 00:00:00'">{{ moment(booking.created_at).format('MMM DD[,] YYYY hh:mm A') }}</p>
								</div>
							</div>
							<div class="col-md-4 mt-1" v-if="booking.future_delivery_date">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Booking Date/Time')}}</h6>
									<p v-if="booking.future_delivery_date != '0000-00-00 00:00:00'">{{ moment(booking.future_delivery_date).format('MMM DD[,] YYYY hh:mm A') }}</p>
								</div>
							</div>
							
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Booking Type')}}</h6>
									<p>{{ booking.booking_type }}</p>
								</div>
							</div>
	
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Number of guest')}}</h6>
									<p>{{ booking.guests_count }}</p>
								</div>
							</div>
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Booking Fee')}}</h6>
									<p>
										<span v-html="currency"></span>
										{{ booking.total_booking_fee }}
									</p>
								</div>
							</div>
							<div class="col-md-4 mt-1">
								<div class="form-group">
									<h6>{{trans.get('__JSON__.Notes')}}</h6>
									<p>{{ booking.notes || '-' }}</p>
								</div>
							</div>
						</div>
					</div>
	
				</div>
			</b-form>
			<template slot="modal-footer">
				<div class="w-100">
					<b-button class="ml-2 btn btn-success"  v-if="booking.status == 'Pending'" @click="acceptBooking(booking.id, booking_statuses.upcoming)" style="float: right !important;">{{ trans.get('__JSON__.Confirm Booking') }}</b-button>
					<b-button class="btn btn-danger" v-if="booking.status == 'Pending'" @click="showReject = true" style="float: right !important;">{{ trans.get('__JSON__.Reject Booking') }}</b-button>
				</div>
			</template>
		</b-modal>

		<booking-reject v-if="showReject" 
		:booking-id="booking.id" 
		@hidden="showReject = false"
		@close-modal="isVisible = false"
		:from-model = "true"
		@refreshData="getBookingData"/>
	</div>


</template>